var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1177.4 279.3" },
      attrs: {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 1177.4 279.3",
        "xml:space": "preserve",
        id: _vm.id,
      },
    },
    [
      _c("svg:style", { attrs: { type: "text/css" } }, [
        _vm._v(
          "\n             #" +
            _vm._s(_vm.id) +
            " > .b8-st0 {\n                  fill: " +
            _vm._s(_vm.color) +
            ";\n              }\n            #" +
            _vm._s(_vm.id) +
            " >  .b8-st1 {\n                  fill: #ffffff;\n              }\n        "
        ),
      ]),
      _vm._v(" "),
      _c("path", {
        staticClass: "b8-st0",
        attrs: {
          d: "M80.2,0h1017c44.3,0,80.2,35.9,80.2,80.2v118.9c0,44.3-35.9,80.2-80.2,80.2H80.2C35.9,279.3,0,243.3,0,199.1\n\tV80.2C0,35.9,35.9,0,80.2,0z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "b8-st1",
        attrs: {
          d: "M205.1,116.7c-5,0.1-9.1,4.3-9,9.3c0.1,5,4.3,9.1,9.3,9c5-0.1,9-4.2,9-9.1C214.4,120.8,210.2,116.7,205.1,116.7\n\tC205.1,116.7,205.1,116.7,205.1,116.7z",
        },
      }),
      _vm._v(" "),
      _c("ellipse", {
        staticClass: "b8-st1",
        attrs: { cx: "148.7", cy: "125.8", rx: "9.3", ry: "9.1" },
      }),
      _vm._v(" "),
      _c("ellipse", {
        staticClass: "b8-st1",
        attrs: { cx: "176.6", cy: "125.8", rx: "9.3", ry: "9.1" },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "b8-st1",
        attrs: {
          d: "M176.9,37.6c-54,0-97.8,43.8-97.8,97.8s43.8,97.8,97.8,97.8s97.8-43.8,97.8-97.8l0,0\n\tC274.6,81.4,230.8,37.6,176.9,37.6z M194.1,181.1c-5.3,4.9-9.7,10.6-13.2,16.9c-0.2,0.6-0.5,1.1-0.8,1.7c-5.7,9.4-10.1,0-10.1,0\n\tc-3.4-7.2-8.1-13.7-13.9-19.2c-23.5-8.2-39.3-30.3-39.4-55.2c0-32.3,26.5-58.6,59.2-58.6s59.2,26.2,59.2,58.6\n\tC235.1,150.9,218.5,173.4,194.1,181.1L194.1,181.1z",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }